export default "__VITE_ASSET__oi1JLbvG__"